import { render, staticRenderFns } from "./VozidloRidicList.vue?vue&type=template&id=1ea8fc94&"
import script from "./VozidloRidicList.vue?vue&type=script&lang=ts&"
export * from "./VozidloRidicList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports